import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { Router } from '@angular/router';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

export interface IImageGalleryDialogModel {
    Images: Array<any>;
    SelectedImage?: any;
    Interval?: number;
}

@Component({
    selector: 'image-gallery',
    templateUrl: './image.gallery.component.html',
    styleUrls: ['./image.gallery.component.scss']
})

export class ImageGalleryDialog extends DialogComponent<IImageGalleryDialogModel, boolean> implements IImageGalleryDialogModel, OnInit, OnDestroy {
    IsBusy: boolean = false;

    Images: Array<any>;
    ActiveImage: any;
    SelectedImage: any;

    Interval: number;
    SequenceInterval;
    ActiveImageProgress: number = 0;

    constructor(dialogService: DialogService, public router: Router, private sweetAlert: SweetAlertService) {
        super(dialogService, router);
    }

    ngOnInit() {
        // this.IsBusy = true;

        // this.Images = [
        //     'http://placehold.it/320x180'
        // ];

        // this.Images = [
        //     'http://placehold.it/1680x1050',
        //     'http://placehold.it/3220x1800',
        //     'http://placehold.it/1920x1080',
        //     'http://placehold.it/1024x768',
        //     'http://placehold.it/2560x1440',
        //     'http://placehold.it/960x720',
        //     'http://placehold.it/3200x1800',
        //     'http://placehold.it/1280x960',
        //     'http://placehold.it/1440x900',
        //     'http://placehold.it/2560x1600'
        // ];

        if (this.SelectedImage) {
            this.ActiveImage = this.SelectedImage;
        } else {
            this.ActiveImage = this.Images[0];
        }

        if (this.Interval) {
            this.StartSequence();
        }

    }

    SetActiveImage(image) {
        this.StopSequence();
        this.ActiveImageProgress = 0;
        this.ActiveImage = image;
    }

    NextImage() {
        this.StopSequence();
        this.ActiveImageProgress = 0;

        let index = this.Images.indexOf(this.ActiveImage);

        if (index == this.Images.length - 1) {
            this.ActiveImage = this.Images[0];
        } else {
            this.ActiveImage = this.Images[index + 1];
        }

    }

    PreviousImage() {
        this.StopSequence();
        this.ActiveImageProgress = 0;

        let index = this.Images.indexOf(this.ActiveImage);

        if (index == 0) {
            this.ActiveImage = this.Images[this.Images.length - 1];
        } else {
            this.ActiveImage = this.Images[index - 1];
        }
    }

    DownloadActiveImage() {
        window.open(this.ActiveImage.src);
    }

    CopyActiveImageLink() {
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (this.ActiveImage));
            e.preventDefault();
            this.sweetAlert.swal({
                type: 'success',
                title: 'Copied to Clipboard',
                text: this.ActiveImage,
                timer: 1500
            }).then( () => {}, () => {} );
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
    }

    DeleteActiveImage() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This cannot be undone.',
            showCancelButton: true
        }).then( () => {}, () => {} );
    }

    StartSequence() {
        this.SequenceInterval = setInterval(() => {
            console.log('trying this out');
            this.ActiveImageProgress++;
            if (this.ActiveImageProgress == 100) {
                let index = this.Images.indexOf(this.ActiveImage);
                this.ActiveImageProgress = 0;
                if (index == this.Images.length - 1) {
                    this.ActiveImage = this.Images[0];
                } else {
                    this.ActiveImage = this.Images[index + 1];
                }
            }
        }, this.Interval / 100);
    }

    StopSequence() {
        clearInterval(this.SequenceInterval);
        this.SequenceInterval = undefined;
    }

    Close() {
        this.StopSequence();
        this.close();
    }

}
